import { Component } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: true,
    imports: [TranslocoModule, MatTabsModule, FlexLayoutModule]
})
export class PrivacyPolicyComponent {
    panelOpenState = false;
    constructor() {}
}
